export default __webpack_public_path__ + "static/media/14.RECEPCION.9504a5fc.jpg";